/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { Col, Row } from 'external/react-bootstrap';
import { translation, Title } from 'plugin/liferay-widgets-react-web';

const FliwasOrganizationDetails = ({ item }) => {
    item = item && (item.item || item);

    return !item ? (
        <div>Kein Element gewählt</div>
    ) : (
        <React.Fragment>
            <Title title={item.title} id={item.id}/>

            <Row className="border-box">
                {item.parentOrganizationName && <Col lg={12} md={12} sm={12} xs={12}>
                    <small >{translation.trans('federal-state')}:</small>
                    <h4>{item.parentOrganizationName}</h4>
                </Col>
                }
                {item.groupFriendlyURL && <Col lg={12} md={12} sm={12} xs={12}>
                    <small >{translation.trans('link')}:</small>

                    <h4><a href={location.origin + '/group' + item.groupFriendlyURL}
                           target="_blank">{translation.trans('go-to-site')}</a></h4>
                </Col>
                }
            </Row>

        </React.Fragment>
    )
};

FliwasOrganizationDetails.propTypes = {
    item: PropTypes.object
};

export default FliwasOrganizationDetails;



// WEBPACK FOOTER //
// ./js/components/FliwasOrganizationDetails.jsx